import React, { useState, useEffect } from "react";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  DialogTitle,
  Typography,
  Dialog,
  DialogActions,
  TextField,
} from "@mui/material";
import Cookies from "universal-cookie";
import {
  getrejected,
  acceptBProfile,
  replayToBProfile,
  searchRejected,
} from "../../actions/businessProfileAction";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { FaImage } from "react-icons/fa";
import { FiMessageCircle, FiCheckCircle, FiEye } from "react-icons/fi";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { APPROVE, FEED, VIEW_DET, VIEW_IMG } from "../../constants/url";
import {
  ERR_POSTING,
  ERR_GETTING,
  ERR_ALERT_TITLE,
} from "../../constants/alertMessage";
import ImageModal from "../../images/imageModal";

const cookies = new Cookies();

const Rejected = () => {
  const localRole = JSON.parse(localStorage.getItem("role"))
  const permissions = localRole && localRole.permissions ? localRole.permissions : "All"
  const [values, setValues] = useState({
    name: "",
    error: "",
    rejected: "",
    success: false,
    removed: false,
    selectedRows: [],
  });
  const [isSendingFeedback, setIsSendingFeedback] = useState(false);
  const [images, setImages] = useState([]);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [feedId, setFeedId] = useState("");
  const [details, setDetails] = useState({});

  const handleClose = () => {
    setOpen(false);
  };
  const handleClose1 = () => {
    setOpen1(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleReplay = (e) => {
    e.preventDefault();
    setIsSendingFeedback(true);
    replayToBProfile( agritech_id,feedId, replay,)
      .then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error, loading: false });

          // Show error message
          Swal.fire({
            title: "Error",
            text: data.error,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        } else {
          setOpen2(false);
          setReplay("");
          loadBType();
          // Show success message
          Swal.fire({
            title: "Success",
            text: "feedback added successfully!",
            icon: "success",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        // Show error message for replayToBProfile failure
        Swal.fire({
          title: "Error",
          text: `${ERR_POSTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      }) .finally(() => {
        setIsSendingFeedback(false); // Add this line
      });
  };
  const { rejected } = values;
  const agritech_id = cookies.get("agritech_token");
  const [replay, setReplay] = useState("");

  useEffect(() => {
    loadBType();
  }, []);

  const loadBType = () => {
    getrejected(agritech_id)
      .then((data) => {
        if (data.error) {
          Swal.fire({
            title: "Error",
            text: `${data.error}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        } else {
          setValues({ ...values, rejected: data.rejected });
        }
      })
      .catch(() => {
        Swal.fire({
          title: "Error",
          text: `${ERR_GETTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      });
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;

    try {
      const response = await searchRejected(searchValue);

      if (response && response.rejected) {
        setValues((prevState) => ({
          ...prevState,
          rejected: response.rejected,
        }));
      } else {
        setValues((prevState) => ({
          ...prevState,
          rejected: [],
        }));
      }
    } catch (error) {
      Swal.fire({
        title: `${ERR_ALERT_TITLE}`,
        text: error.message,
        icon: "error",
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: "OK",
      });
    }
  };

  const handleChange = (name) => (e) => {
    setReplay(e.target.value);
  };

  function edit(cell, row, extraData, index) {
    const handleImageClick = () => {
      const imagesData = [row.image1, row.image2, row.image3, row.image4];

      const filteredImagesData = imagesData.filter(
        (image) => image !== undefined && image !== null && image !== ""
      );

      setImages(filteredImagesData);
      setOpen(true);
    };

    const hasImageData = [row.image1, row.image2, row.image3, row.image4].some(
      (image) => image !== undefined && image !== null && image !== ""
    );
    const handlePOP = (e) => {
      setDetails(row);
      console.log(details.name);

      setOpen1(true);
    };

    const handleAcceptClick = (e) => {
      Swal.fire({
        title: `Approve ${row.company_name}`,
        text: "",
        icon: "success",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      })
        .then((result) => {
          if (result.isConfirmed) {
            acceptBProfile(agritech_id, row.id).then((data) => {
              if (data.error) {
                setValues({ ...values, error: data.error, loading: false });
              } else {
                var selections = rejected;
                selections.splice(index, 1);

                setValues({ ...values, rejected: selections });
              }
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error",
            text: `${ERR_POSTING}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        });
    };
    const handleS = (e) => {
      // Perform the state updates only if confirmed
      setFeedId(row.id);
      setOpen2(true);
    };

    return (
      <span>
        {permissions.some(item => item.keyword === "businessProfilesRejectedList" && item.isApprove == true) &&
          <>
            <i data-tooltip-id="1" data-tooltip-content={`${APPROVE}`}>
              <FiCheckCircle
                onClick={handleAcceptClick}
                title="approve"
                color="#4fbde9"
                size="20"
              />
            </i>
            <Tooltip id="1" />
          </>
        }
        {permissions.some(item => item.keyword === "businessProfilesRejectedList" && item.isFeedback == true) &&
          <>
            {row.replay !== "" ? (
              <i
                className="ml-1"
                data-tooltip-id="2"
                data-tooltip-content={`${FEED}`}
              >
                {" "}
                <FiMessageCircle
                  onClick={handleS}
                  title="message"
                  color="#769A0F"
                  size="20"
                />
              </i>
            ) : (
              <i
                className="ml-1"
                data-tooltip-id="2"
                data-tooltip-content={`${FEED}`}
              >
                {" "}
                <FiMessageCircle
                  onClick={handleS}
                  title="message"
                  color="#f9bc0b"
                  size="20"
                />
              </i>
            )}
            <Tooltip id="2" />
          </>
        }
        <i
          className="ml-1"
          data-tooltip-id="3"
          data-tooltip-content={`${VIEW_DET}`}
        >
          {" "}
          <FiEye onClick={handlePOP} color="#9368f3" size="20" />
        </i>
        <Tooltip id="3" />

        {hasImageData && (
          <i
            className="ml-1"
            data-tooltip-id="5"
            data-tooltip-content={`${VIEW_IMG}`}
          >
            {" "}
            <FaImage onClick={handleImageClick} color="green" size="17" />
          </i>
        )}
        <Tooltip id="5" />
      </span>
    );
  }

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#769A0F" />
      <Sidebar type="businessProfiles" />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        {" "}
                        <Link to="/dashBoard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Rejected List</li>
                    </ol>
                  </div>
                  <h4 className="page-title">
                    Business Profile - Rejected List
                  </h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card-box">
                  <div style={{ width: "98%" }}>
                    <div
                      style={{
                        marginLeft: "auto",
                        width: "200px",
                        marginBottom: "20px",
                        position: "relative",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search..."
                        className="form-control"
                        style={{
                          width: "100%",
                          paddingLeft: "30px",
                          boxSizing: "border-box",
                        }}
                        onChange={(e) => {
                          handleSearch(e);
                          if (e.target.value.trim() === "") {
                            e.target.nextElementSibling.style.display =
                              "inline-block";
                          } else {
                            e.target.nextElementSibling.style.display = "none";
                          }
                        }}
                      />
                      <i
                        className="fas fa-search"
                        style={{
                          position: "absolute",
                          left: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#aaa",
                        }}
                      ></i>
                    </div>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">S.No</TableCell>
                            <TableCell align="left">Customer Name</TableCell>
                            <TableCell align="left">Customer Mobile</TableCell>
                            <TableCell align="left">Company Name</TableCell>
                            <TableCell align="left">Business Type</TableCell>
                            {/* <TableCell align="left">
                              Image
                            </TableCell> */}
                            <TableCell align="left">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Array.isArray(rejected) &&
                            rejected.map((row, index) => (
                              <TableRow key={row._id}>
                                <TableCell align="left">{index + 1}</TableCell>
                                <TableCell align="left">{row.name}</TableCell>
                                <TableCell align="left">
                                  {row.customer_mobile_no}
                                </TableCell>
                                <TableCell align="left">
                                  {row.company_name}
                                </TableCell>
                                <TableCell align="left">{row.btype}</TableCell>

                                <TableCell align="left">
                                  {edit(null, row, null, index)}
                                </TableCell>
                              </TableRow>
                            ))}

                          {/* <Dialog
                            onClose={handleClose}
                            open={open}
                            fullWidth
                            disableEnforceFocus
                            maxWidth="lg"
                          >
                            <DialogTitle
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              <Typography variant="h6" sx={{ flexGrow: 1 }}>
                                Images
                              </Typography>
                              <Button
                                onClick={handleClose}
                                color="inherit"
                                sx={{ mr: 0 }}
                              >
                                <span
                                  style={{ fontSize: "20px" }}
                                  aria-hidden="true"
                                >
                                  &#128473;
                                </span>
                              </Button>
                            </DialogTitle>

                            <Grid
                              container
                              
                              alignItems="center"
                              style={{
                                maxHeight: "80vh", // Ensures the modal content doesn't exceed viewport height
                                overflowY: "auto",
                              }}
                            >
                              {images.map(
                                (image, index) =>
                                  image && (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={3}
                                      key={index}
                                    >
                                      <img
                                        className="img-responsive"
                                        src={image}
                                        alt="user"
                                        style={{
                                          width: "100rem",
                                          height: "100rem",
                                          maxWidth: "260px",
                                          maxHeight: "350px",
                                          borderRadius: "4px",
                                          marginBottom: "10px",
                                          margin: "8px",
                                        }}
                                      />
                                    </Grid>
                                  )
                              )}
                            </Grid>

                            <DialogActions>
                              <Button
                                variant="outlined"
                                color="error"
                                style={{
                                  marginRight: "3px",
                                  marginBottom: "3px",
                                }}
                                onClick={handleClose}
                              >
                                Close
                              </Button>
                            </DialogActions>
                          </Dialog> */}

                          <ImageModal
                            handleClose={handleClose}
                            open={open}
                            imageSrc={images}
                          ></ImageModal>

                          <Dialog
                            open={open1}
                            onClose={handleClose1}
                            aria-labelledby="details-modal-title"
                            aria-describedby="details-modal-description"
                            style={{
                              maxHeight: "80vh",
                              overflowY: "auto",
                              marginTop: "100px",
                            }}
                            fullWidth
                            disableEnforceFocus
                            maxWidth="lg"
                          >
                            <Grid
                              container
                              justifyContent="center"
                              alignItems="center"
                              className="modal-content"
                            >
                              <Grid item xs={12} className="modal-header">
                                <h5 id="details-modal-title">Details</h5>
                                <Button onClick={handleClose1} color="inherit">
                                  {" "}
                                  <span
                                    style={{ fontSize: "20px" }}
                                    aria-hidden="true"
                                  >
                                    &#128473;
                                  </span>
                                </Button>
                              </Grid>
                              <Grid item xs={12} className="modal-body">
                                <Table className="col-12">
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Customer Name
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.name}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Customer Mobile
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.customer_mobile_no}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Business Type
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.btype}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Company Name
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.company_name}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Description
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.description}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Contact Person
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.contact_person}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Contact Number
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.contact_number}
                                    </TableCell>
                                  </TableRow>

                                  <TableRow>
                                    <TableCell className="text-left">
                                      Location
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.address}
                                    </TableCell>
                                  </TableRow>
                                  {/* <TableRow>
                                    <TableCell className="text-left">
                                      Charges
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.charges}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Delivery Available
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.deliveryAvailable}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Free Delivery
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.freeDelivery}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell className="text-left">
                                      Charges After
                                    </TableCell>
                                    <TableCell className="text-dark text-right font-weight-normal">
                                      {details.chargesAfter}
                                    </TableCell>
                                  </TableRow> */}
                                </Table>
                              </Grid>
                              <Grid item xs={12} className="modal-footer">
                                <Button
                                  onClick={handleClose1}
                                  variant="outlined"
                                  color="error"
                                >
                                  Close
                                </Button>
                              </Grid>
                            </Grid>
                          </Dialog>
                          <Dialog
                            open={open2}
                            onClose={handleClose2}
                            maxWidth="lg"
                            fullWidth
                            centered
                            disableEnforceFocus
                          >
                            <div
                              style={{
                                backgroundColor: "#fff",
                                padding: "20px",
                                // minWidth: '500px',
                                borderRadius: "8px",
                              }}
                            >
                              <h3>Feedback</h3>
                              <form onSubmit={handleReplay}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    <div className="text-left text-dark mb-1">
                                      Message
                                    </div>
                                    <TextField
                                      type="text"
                                      fullWidth
                                      multiline
                                      rows={4}
                                      variant="outlined"
                                      value={replay}
                                      placeholder="Message"
                                      onChange={handleChange()}
                                      required
                                    />
                                  </Grid>
                                </Grid>
                                <Grid
                                  container
                                  justifyContent="flex-end"
                                  style={{ marginTop: "20px" }}
                                >
                                  <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={handleClose2}
                                    style={{ marginRight: "8px" }}
                                  >
                                    Close
                                  </Button>
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={isSendingFeedback}
                                    style={{
                                      backgroundColor: "#769A0F",
                                      color: "#fff",
                                    }}
                                  >
                                    {isSendingFeedback ? "Sending..." : "Send"}
                                  </Button>
                                </Grid>
                              </form>
                            </div>
                          </Dialog>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rejected;
